'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ComplianceIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="ComplianceIcon">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke={sx?.color ? sx.color : '#273443'}
      >
        <g clipPath="url(#clip0_3174_11426)">
          <path d="M20.5 20.6499L16.57 21.4399" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M17 17L15.15 17.76C14.8551 17.8801 14.5249 17.8801 14.23 17.76C14.0183 17.671 13.8367 17.523 13.7066 17.3338C13.5765 17.1446 13.5034 16.922 13.496 16.6925C13.4887 16.4629 13.5473 16.2361 13.665 16.0389C13.7827 15.8418 13.9545 15.6825 14.16 15.58L16 14.68C16.2284 14.561 16.4824 14.4992 16.74 14.5C16.9344 14.4991 17.1275 14.533 17.31 14.6L20.69 15.89"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.5 21.5H10.9L13.23 23.27C13.3459 23.4031 13.5096 23.4851 13.6856 23.4982C13.8616 23.5113 14.0357 23.4545 14.17 23.34L17.67 20.54C17.806 20.4251 17.8923 20.2621 17.911 20.0851C17.9296 19.908 17.8791 19.7306 17.77 19.59L15.85 17.47"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14 15.6799L13.75 15.4699C13.4994 15.281 13.1939 15.1792 12.88 15.1799C12.6945 15.1807 12.511 15.2181 12.34 15.2899L9.5 16.4999"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.5 22.5H8.5C8.76522 22.5 9.01957 22.3946 9.20711 22.2071C9.39464 22.0196 9.5 21.7652 9.5 21.5V16.5C9.5 16.2348 9.39464 15.9804 9.20711 15.7929C9.01957 15.6054 8.76522 15.5 8.5 15.5H6.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.5 22.5H21.5C21.2348 22.5 20.9804 22.3946 20.7929 22.2071C20.6054 22.0196 20.5 21.7652 20.5 21.5V16.5C20.5 16.2348 20.6054 15.9804 20.7929 15.7929C20.9804 15.6054 21.2348 15.5 21.5 15.5H23.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17 0.5H3.5C2.70435 0.5 1.94129 0.81607 1.37868 1.37868C0.81607 1.94129 0.5 2.70435 0.5 3.5V23C0.5 23.1326 0.552678 23.2598 0.646447 23.3536C0.740215 23.4473 0.867392 23.5 1 23.5H4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M3.5 4.5H11.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3.5 7.5H11.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3.5 10.5H7" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M14.5 13V3C14.5 2.33696 14.7634 1.70107 15.2322 1.23223C15.7011 0.763392 16.337 0.5 17 0.5C18.38 0.5 19.5 1.62 19.5 3.5H14.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_3174_11426">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

ComplianceIcon.propTypes = {
  sx: PropTypes.object
}
